import { __assign } from "tslib";
// @ts-nocheck
import classNames from 'classnames';
import { notification } from '@tencent/tea-component';
export var buyNotification = {
    success: function (options) { return notification.success(__assign(__assign({}, options), { className: classNames(options.className, 'buy-notification-success') })); },
    error: function (options) { return notification.error(__assign(__assign({}, options), { className: classNames(options.className, 'buy-notification-error') })); },
    warning: function (options) { return notification.warning(__assign(__assign({}, options), { className: classNames(options.className, 'buy-notification-warning') })); },
    config: function (options) { return notification.config(options); },
};
//# sourceMappingURL=BuyNotification.js.map